"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const initiativeItems = [{
  id: 1,
  title: "SPEED THE LIGHT",
  description: "Speed the Light equipa a los misioneros con herramientas esenciales de transporte y comunicación para difundir el Evangelio eficazmente en todo el mundo.",
  buttonText: "MÁS INFORMACIÓN",
  link: "/MinistriesPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/speed_the_light_missionary_vehicle.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/speed_the_light_missionary_vehicle.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/speed_the_light_missionary_vehicle.png-wvc-sizes",
  imageAlt: "Speed the Light safari missionary vehicle in rural outreach"
}, {
  id: 2,
  title: "BGMC",
  description: "El Desafío Misionero de Niños y Niñas (BGMC), un ministerio de las Asambleas de Dios, capacita a los niños para impactar al mundo apoyando las misiones a través de la educación, recursos e iniciativas de recaudación de fondos.",
  buttonText: "MÁS INFORMACIÓN",
  link: "/MinistriesPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/bgmc_children_education_missions.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/bgmc_children_education_missions.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/bgmc_children_education_missions.png-wvc-sizes",
  imageAlt: "Children in school classroom benefiting from BGMC initiatives"
}];
export default function Initiatives() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="missioninitiatives" data-nav="light" className="relative w-full bg-background py-12 md:py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8">
          {initiativeItems.map((item, i) => <motion.div key={item.id} data-index={i} initial={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 0,
          y: 24
        }} whileInView={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-50px"
        }} transition={{
          duration: 0.5,
          delay: i * 0.15,
          ease: "easeOut"
        }} className="group relative flex flex-col justify-end overflow-hidden rounded-3xl bg-muted shadow-md min-h-[460px] sm:min-h-[500px] lg:min-h-[540px]">
              {}
              <div className="absolute inset-0 z-0">
                <img src={item.imageSrc} data-wvc-srcset={item.imageSrcset} data-wvc-sizes={item.imageSizes} alt={item.imageAlt} loading="lazy" decoding="async" className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105" />
              </div>

              {}
              <div className="relative z-10 p-4 sm:p-6 lg:p-8">
                <div className="rounded-2xl bg-card p-6 shadow-lg backdrop-blur-xs md:p-8">
                  <h2 className="font-default text-2xl font-bold tracking-tight text-card-foreground sm:text-3xl">
                    {item.title}
                  </h2>
                  <p className="mt-3 font-default text-sm leading-relaxed text-muted-foreground sm:text-base">
                    {item.description}
                  </p>
                  <div className="mt-6 flex items-center">
                    <Button asChild className="rounded-full bg-foreground text-background hover:bg-foreground/90 px-5 py-2.5 text-xs font-semibold tracking-wider uppercase shadow-xs transition-all">
                      <Link to={item.link} className="inline-flex items-center gap-1.5">
                        <span>{item.buttonText}</span>
                        <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}